export default {
      labels: {
        headerTitle: 'Detail of Charge',
        chargesTitle: 'Charge supports',
        pendingSupportFiles: 'Pending support files',
        receivedSupportFiles: 'Attached support files',
        observations: 'Observations'
      },
}